<template>
  <div class="grey lighten-3">
    <v-card>
      <v-card-title>
        NOAA Compliance
      </v-card-title>
      <v-container>
        <v-form>
          <v-row>
            <v-col
              cols="6"
              md="4"
            >
              <v-text-field
                v-model="select"
                :loading="loading"
                flat
                hide-no-data
                hide-details
                label="Enter lead id"
                @blur="backendSearch()"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="haveAdverseAction === true"
          >
            <v-col
              cols="6"
              md="3"
            >
              <v-btn
                :loading="generatingTemplate"
                class="btn-bg-deep-blue"
                depressed
                @click="generateTemplate()"
              >
                Generate NOAA Template
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="haveAdverseAction === false"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-alert
                border="top"
                color="red lighten-2"
                dark
              >
                There is no adverse action associated to this lead.
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            v-if="backendErrorMessage"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-alert
                border="top"
                color="red lighten-2"
                dark
              >
                {{ backendErrorMessage }}
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
    <v-card
      v-if="select && templateString"
      :loading="generatingTemplate"
      class="mt-5"
    >
      <v-card-text>
        <div>
          <div class="exist-adverse-action">
            <v-row>
              <v-col
                v-if="templateString"
                sm="12"
                md="12"
              >
                <v-icon
                  large
                  :color="(activeView === 'code') ? 'green darken-2' : 'grey darken-2'"
                  class="cursor-pointer"
                  @click="changeActiveView('code')"
                >
                  mdi-code-block-tags
                </v-icon>
                <v-icon
                  large
                  :color="(activeView === 'view') ? 'green darken-2' : 'grey darken-2'"
                  class="cursor-pointer"
                  @click="changeActiveView('view')"
                >
                  mdi-view-dashboard-outline
                </v-icon>

                <v-textarea
                  v-if="activeView === 'code'"
                  v-model="templateString"
                  required
                  auto-grow
                  label="Template String"
                />
                <div
                  v-if="activeView === 'view'"
                >
                  <v-card>
                    <v-card-title>
                      Template HTML
                    </v-card-title>
                    <v-card-text>
                      <div v-html="templateString" />
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { debounce } from 'lodash';

export default defineComponent({
  name: 'ComplianceNoaaIndex',

  data() {
    return {
      loading: false,
      checkingAA: false,
      items: [],
      search: null,
      select: null,
      haveAdverseAction: null,
      adverseAction: null,
      generatingTemplate: false,
      templateString: '',
      activeView: 'code',
      backendErrorMessage: '',
    };
  },

  watch: {
    select: debounce(function (value) {
      if (value) {
        this.backendSearch(value);
      } else {
        this.haveAdverseAction = null;
      }
    }, 500),
  },

  methods: {
    changeActiveView(selectedView) {
      this.activeView = selectedView;
    },

    async backendSearch() {
      this.backendErrorMessage = '';
      this.templateString = '';
      this.loading = true;

      try {
        if (this.select) {
          const { status } = await this.$axios.get(`api/v1/compliance/noaa/${this.select}`);

          if (status === 200) {
            await this.checkAdverseAction();
          }
        }
      } catch (err) {
        this.backendErrorMessage = err.response?.data?.message ?? 'Ups something wrong';
      } finally {
        this.loading = false;
      }
    },

    async checkAdverseAction() {
      this.checkingAA = true;

      try {
        const { data, status } = await this.$axios.post('api/v1/compliance/noaa/checkAA', {
          leadId: this.select,
        });

        if (status === 200) {
          this.adverseAction = data.data;
          this.haveAdverseAction = true;
        } else {
          this.haveAdverseAction = false;
        }
      } catch (err) {
        this.haveAdverseAction = false;
        console.info(err);
      } finally {
        this.checkingAA = false;
      }
    },

    async generateTemplate() {
      this.generatingTemplate = true;

      try {
        const { data, status } = await this.$axios.post('api/v1/compliance/noaa/generate-template', {
          leadId: this.select,
        });

        if (status === 200) {
          this.templateString = data.data;
        }
      } catch (err) {
        console.info(err);
      } finally {
        this.generatingTemplate = false;
      }
    },
  },
});
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
